import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthChange, buscarUsuario, cadastrar, entrar, entrarComGoogle, sair, vincularGoogleComSenha, recuperarSenha } from "../services/firebase";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // Firebase Auth user
  const [userData, setUserData] = useState(null); // Dados extras do Firestore
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthChange(async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        const data = await buscarUsuario(firebaseUser.uid);
        setUserData(data);
      } else {
        setUserData(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const handleCadastrar = async (dados) => {
    const u = await cadastrar(dados);
    return u;
  };

  const handleEntrar = async ({ email, senha }) => {
    const u = await entrar({ email, senha });
    return u;
  };

  const handleSair = async () => {
    await sair();
  };

  const handleEntrarComGoogle = async () => {
    const u = await entrarComGoogle();
    return u;
  };

  const handleVincularGoogleComSenha = async (senha, error) => {
    const u = await vincularGoogleComSenha(senha, error);
    return u;
  };

  const handleRecuperarSenha = async (email) => {
    await recuperarSenha(email);
  };

  return (
    <AuthContext.Provider
      value={{ user, userData, loading, cadastrar: handleCadastrar, entrar: handleEntrar, entrarComGoogle: handleEntrarComGoogle, sair: handleSair, vincularGoogleComSenha: handleVincularGoogleComSenha, recuperarSenha: handleRecuperarSenha }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
